import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import _find from 'lodash/find';

import '../../css/sub-nav.css';

class AdminNav extends Component {
    constructor(props) {
        super(props);

        // console.log(props.match)

        this.state = {
            sectionRoutes: [
                {
                    title: 'Cart',
                    routes: [
                        {
                            title: 'Dashboard',
                            path: '/admin',
                            exact: true,
                        },
                        {
                            title: 'View Orders',
                            path: '/admin/view-orders',
                            exact: false,
                        },
                        {
                            title: 'Cart Settings',
                            path: '/admin/settings',
                            exact: true,
                        },
                        {
                            title: 'Pickup Settings',
                            path: '/admin/pickup',
                            exact: true,
                        },
                        {
                            title: 'Merchant Settings',
                            path: '/admin/merchant',
                            exact: true,
                        },
                        {
                            title: 'Favicon',
                            path: '/admin/favicon',
                            exact: true,
                        },
                    ],
                },
                {
                    title: 'Products',
                    routes: [
                        {
                            title: 'Add Product',
                            path: '/admin/products/add',
                            exact: true,
                        },
                        {
                            title: 'Edit Product',
                            path: '/admin/products/edit',
                            exact: false,
                        },
                        {
                            title: 'Add Category',
                            path: '/admin/categories/add',
                            exact: true,
                        },
                        {
                            title: 'Edit Category',
                            path: '/admin/categories/edit',
                            exact: false,
                        },
                        {
                            title: 'Set Category Order',
                            path: '/admin/categories/sort',
                            exact: false,
                        },
                    ],
                },
                {
                    title: 'Pricing',
                    routes: [
                        {
                            title: 'Product Prices',
                            path: '/admin/prices',
                            exact: true,
                        },
                        {
                            title: 'Promotions',
                            path: '/admin/promotions',
                            exact: true,
                        },
                        {
                            title: 'Discounts',
                            path: '/admin/discounts',
                            exact: true,
                        },
                    ],
                },
                {
                    title: 'Locations',
                    routes: [
                        {
                            title: 'Add Store Locations',
                            path: '/admin/store-locations/add',
                            exact: true,
                        },
                        {
                            title: 'Edit Store Locations',
                            path: '/admin/store-locations/edit',
                            exact: false,
                        },
                    ],
                },
                {
                    title: 'Misc',
                    routes: [
                        {
                            title: 'Content Pages',
                            path: '/admin/pages',
                            exact: false,
                        },
                        {
                            title: 'Notices',
                            path: '/admin/notices',
                            exact: true,
                        },
                        {
                            title: 'Banners',
                            path: '/admin/banners',
                            exact: true,
                        },
                        {
                            title: 'Banners Sort',
                            path: '/admin/banners/order',
                            exact: true,
                        },
                        {
                            title: 'Promos',
                            path: '/admin/promos',
                            exact: true,
                        },
                        {
                            title: 'Receipt Options',
                            path: '/admin/receipt',
                            exact: true,
                        },
                        {
                            title: 'Taxes',
                            path: '/admin/taxes',
                            exact: true,
                        },
                    ],
                },
                {
                    title: 'User',
                    routes: [
                        {
                            title: 'Logout',
                            path: '/admin/logout',
                            exact: true,
                        },
                    ],
                },
            ],
            openSections: [],
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // If the path is the same, do nothing
        if (!nextProps.route.path || this.props.route.path === nextProps.route.path)
            return;

        // Loop over routes to see if the active route needs to be added to openSections
        this.state.sectionRoutes.map((section) => {
            // Find the path
            const result = _find(
                section.routes,
                (route) => nextProps.route.path === route.path
            );

            if (result) {
                // If the path title is already in openSections, do nothing
                if (this.state.openSections.indexOf(section.title) > -1) return null;

                // Finally, add the section title to openSections
                this.setState({
                    openSections: [...this.state.openSections, section.title],
                });
            }

            return null;
        });
    }

    handleSectionClick = (sectionTitle) => {
        const titleIndex = this.state.openSections.indexOf(sectionTitle);

        // console.log(this.state.openSections)

        if (titleIndex > -1) {
            this.setState({
                openSections: this.state.openSections.filter(
                    (title, i) => i !== titleIndex
                ),
            });
        } else {
            this.setState({ openSections: [...this.state.openSections, sectionTitle] });
        }
    };

    isSectionOpen(section, currentPath = '') {
        // const currentPath = !!this.props.route.path ? this.props.route.path : ''
        // let initialRenderOr = initialRender ? _find(section.routes, route => currentPath === route.path) : 0

        // Is the current path the current route OR has been opened manually
        // const result = _find(section.routes, route => currentPath === route.path) ||
        //                _find(this.state.openSections, title => title === section.title)

        const result = _find(this.state.openSections, (title) => title === section.title);

        // console.log('isSectionOpen', result)

        return result;
    }

    render() {
        // console.log('Nav:', this.props.route)
        return (
            <div className="sub_nav">
                <div className="title">Admin Menu</div>

                <nav>
                    {this.state.sectionRoutes.map((section) => (
                        <div key={section.title} className="nav_section">
                            <div
                                className={
                                    'section_title' +
                                    (this.isSectionOpen(section) ? ' open' : '')
                                }
                                onClick={(e) => this.handleSectionClick(section.title)}
                            >
                                {section.title}
                            </div>
                            <div>
                                {section.routes.map((route) => (
                                    <NavLink
                                        key={route.title}
                                        activeClassName="active"
                                        to={route.path}
                                        exact={!!route.exact}
                                    >
                                        {route.title}
                                    </NavLink>
                                ))}
                            </div>
                        </div>
                    ))}
                </nav>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        route: state.route,
    };
};

export default connect(mapStateToProps)(AdminNav);



// WEBPACK FOOTER //
// ./src/components/admin/AdminNav.js